<ng-content></ng-content>
<div mat-dialog-title>
  <ng-content select="[dialog-title]"></ng-content>
</div>

<div mat-dialog-content [class.-loading]="loading">
  <ng-content select="[dialog-content]" *ngIf="!loading"></ng-content>
  <div class="overlay" *ngIf="loading">
    <span class="fa fa-spinner fa-spin fa-3x"></span>
  </div>
</div>

<div mat-dialog-actions [align]="actionsAlign" *ngIf="!loading">
  <ng-content select="[dialog-actions]"></ng-content>
</div>

<button class="btn btn-primary btn-close" mat-dialog-close *ngIf="!hideClose">
  <img class="x-icon" alt="close-icon" src="../../assets/icons/close-icon-white.svg" />
</button>
